import { LoaderTemplate } from 'common/module/loader/template';
import { LoaderViewStore } from 'common/module/loader/view-store';
import { LoaderViewStoreFactory } from 'common/module/loader/view-store.factory';
import { PreactView } from 'common/module/preact/view';
import { ViewDynamicInterface } from 'common/module/view/dynamic.interface';

export function LoaderViewDynamicFactory(): ViewDynamicInterface<LoaderViewStore> {
  return new PreactView(LoaderTemplate, LoaderViewStoreFactory());
}
